var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx } from '@emotion/css';
import { ColorSemanticHex } from '@axafr-btc-ds/colors';
import { getDefaultComponentFromVariant } from './utils';
import { getTypoStyle } from './css';
export var Typography = function (_a) {
    var children = _a.children, className = _a.className, variant = _a.variant, _b = _a.color, color = _b === void 0 ? ColorSemanticHex.textBody : _b, _c = _a.bodyFontWeight, bodyFontWeight = _c === void 0 ? '400' : _c, _d = _a.textAlign, textAlign = _d === void 0 ? 'left' : _d, component = _a.component, props = __rest(_a, ["children", "className", "variant", "color", "bodyFontWeight", "textAlign", "component"]);
    var Component = React.useMemo(function () { return component !== null && component !== void 0 ? component : getDefaultComponentFromVariant(variant); }, [component, variant]);
    var typoStyle = React.useMemo(function () { return getTypoStyle({ variant: variant, color: color, bodyFontWeight: bodyFontWeight, textAlign: textAlign }); }, [variant, color, bodyFontWeight, textAlign]);
    return (React.createElement(Component, __assign({}, props, { className: cx(typoStyle, className) }), children));
};
